export default __webpack_public_path__ + "static/fortune_hero-97882758aaae9cacd261a1a2db7c2947.png";